/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable unicorn/no-null */
/* eslint-disable unicorn/no-array-for-each */
import Modal from '../../components/Modal';

import SelectorEngine from '../../utils/dom/selector-engine';
import Request from '../../utils/request';
import { scrollToTop } from '../../utils/misc';

class AccountDetailsMembership {
	constructor() {
		this._wrapper = undefined;
		this._cancelModal = undefined;
		this._existingMembership = undefined;

		this.initiateSection();
	}

	initiateSection() {
		this._wrapper = SelectorEngine.findOne('.p-account-details-membership');

		if (this._wrapper !== null) {
			const backButton = SelectorEngine.findOne('.js-account-membership-back', this._wrapper);
			backButton.addEventListener('click', this.redirectToUrl);

			const exitButtons = SelectorEngine.find('.js-account-mebership-exit', this._wrapper);
			exitButtons.forEach((exitButton) => {
				exitButton.addEventListener('click', this.redirectToUrl);
			});

			const exisitngMembership = SelectorEngine.findOne('#existing__membership');
			this._existingMembership = exisitngMembership.dataset.package;

			const selectPackageCtas = SelectorEngine.find('.js-membership-select-id', this._wrapper);
			selectPackageCtas.forEach((cta) => {
				cta.addEventListener('click', this.setMembershipId.bind(this));
			});

			const dismissError = SelectorEngine.findOne('.js-dismiss-submit-error', this._wrapper);
			dismissError.addEventListener('click', () => {
				const errorPopup = SelectorEngine.findOne('.lta-onboarding-submit--error');
				errorPopup.classList.add('u-hidden');
			});
			// if membership is cancellable
			const cancelButton = SelectorEngine.findOne('.js-cancel-mebership', this._wrapper);
			if (cancelButton !== null) {
				this._cancelModal = new Modal(SelectorEngine.findOne('#cancel-membership'), {});
				cancelButton.addEventListener('click', () => {
					this._cancelModal.show();
				});

				const noCancelModal = SelectorEngine.findOne('.js-account-membership-continue', this._wrapper);
				noCancelModal.addEventListener('click', () => {
					this._cancelModal.hide();
				});

				const cancelModal = SelectorEngine.findOne('.js-account-membership-cancel', this._wrapper);
				cancelModal.addEventListener('click', this.cancelMembership.bind(this));
			}

			const enableButton = SelectorEngine.findOne('.js-reenable-mebership');
			if (enableButton !== null) {
				enableButton.addEventListener('click', () => this.reEnableMembership());
			}
		}
	}

	redirectToUrl(event, eventUrl = null) {
		const rootUrl = window.location.origin;
		const url = eventUrl || event.currentTarget.dataset.target;
		window.location.href = `${rootUrl}${url}`;
	}

	async cancelMembership() {
		const cancelResponse = await Request.post('/api/account/membership/cancel').catch((error) => {
			this._cancelModal.hide();
			this.showError(error.Message);
		});
		if (cancelResponse.statusCode === '02') {
			location.reload();
		} else {
			this._cancelModal.hide();
			this.showError(cancelResponse.response);
		}
	}

	async reEnableMembership() {
		const enableResponse = await Request.post('/api/account/membership/resubscribe').catch((error) => {
			this.showError(error.Message);
		});
		if (enableResponse.statusCode === '02') {
			location.reload();
		} else {
			this.showError(enableResponse.response);
		}
	}

	setMembershipId(event) {
		const target = event.currentTarget;
		const redirectUrl = target.dataset.target;
		const membershipId = target.dataset.package;
		const existingMembershipId = this._existingMembership;

		sessionStorage.removeItem('checkout-id');
		sessionStorage.removeItem('existing-membership-id');
		sessionStorage.setItem('checkout-id', membershipId);
		sessionStorage.setItem('existing-membership-id', existingMembershipId);
		this.redirectToUrl(null, redirectUrl);
	}

	showError(error) {
		const errorPopup = document.querySelector('.lta-onboarding-submit--error');
		const popupTitle = SelectorEngine.findOne('.title', errorPopup);
		popupTitle.innerHTML = error;
		errorPopup.classList.remove('u-hidden');
		scrollToTop();
	}
}

const globalAccountDetailsMembership = new AccountDetailsMembership();

export default globalAccountDetailsMembership;
